// Bootstrap Link
import "././node_modules/bootstrap/dist/css/bootstrap.min.css"
import "././node_modules/bootstrap/dist/js/bootstrap.bundle"
import './src/styles/style.scss'; 
import './src/styles/responsive.scss';

export const onRouteUpdate = ({ location, prevLocation }) => {
    window.scrollTo(0, 0);
};